import CircularProgress from 'material-ui/CircularProgress';
import React, { Component } from 'react';
import autoBind from 'react-autobind';
import { connect } from 'react-redux';

import { Entities, fetchById, getUpdatedEntity, patch, save } from 'src/common/index';

import ErrorMessage from 'src/components/misc/error-message';
import EventCategoryForm from 'src/components/admin/event-tickets/categories/event-category-form';

class EventCategoryModal extends Component {
    constructor(props) {
        super(props);
        autoBind(this);

        this.state = {
            startedFetching: false,
        };
    }

    componentWillMount() {
        const { isCreate, id } = this.props;

        if (!isCreate) this.props.fetchById(id, Entities.TICKET_EVENT_CATEGORY);
        else this.setState({ startedFetching: true });
    }

    componentWillReceiveProps(nextProps) {
        const { eventCategory } = nextProps;

        if (!this.state.startedFetching && eventCategory.isFetching) this.setState({ startedFetching: true });
    }

    callSubmit() {
        return this.childForm.submit();
    }

    didFormChange() {
        return !this.childForm.pristine;
    }

    render() {
        const { eventCategory, isCreate, t } = this.props;

        const finishFetching = this.state.startedFetching && !eventCategory.isFetching;

        if (finishFetching) {
            // check for errors
            if (eventCategory.error) return <ErrorMessage object={eventCategory} />;
            // if everything is ok populate form
            else {
                let initialValues = {};

                // populate form for editing an existing event category
                if (!isCreate && eventCategory.content)
                    initialValues = {
                        id: eventCategory.content.id,
                        name: eventCategory.content.name,
                        description: eventCategory.content.description || '',
                    };

                return (
                    <EventCategoryForm
                        initialValues={initialValues}
                        onSubmit={this.handleSubmit}
                        eventCategory={eventCategory.content}
                        t={t}
                        ref={ref => (this.childForm = ref)}
                    />
                );
            }
        } else return <CircularProgress />;
    }

    handleSubmit(data) {
        const { isCreate, handleClose } = this.props;

        if (!isCreate) this.props.patch(data, Entities.TICKET_EVENT_CATEGORY);
        else this.props.save(data, Entities.TICKET_EVENT_CATEGORY);

        handleClose();
    }
}

const mapStateToProps = state => {
    return {
        eventCategory: getUpdatedEntity(state, Entities.TICKET_EVENT_CATEGORY),
    };
};

export default connect(
    mapStateToProps,
    {
        fetchById,
        patch,
        save,
    },
    null,
    { withRef: true },
)(EventCategoryModal);
